import React, { useEffect } from 'react';
import './ourteam.css';
import { FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa'; // import social media icons

// Your images and team data
import Staff1 from '../../assets/Team/faculty_jb.jpg';
import Staff2 from '../../assets/Team/faculty_pkg.jpg';

import President from '../../assets/Team/Ankan Kumar Kundu.jpg';
import VicePresident from '../../assets/Team/Souvik Sarkar.jpg';
import Secretary from '../../assets/Team/Anamitra Hazra.jpeg';
import convenor from '../../assets/Team/Sahil Yadav.jpg';
import Treasurer from '../../assets/Team/Pritam Das.png';
import Asst_Secretary from '../../assets/Team/Ananthula Sriharshita.png';
import sponsorship from '../../assets/Team/Annwesha Naskar.png';
import PR from '../../assets/Team/Begari Prashanth.png';
import TechHead from '../../assets/Team/Ankit Pratap.png';

import SecondYear1 from '../../assets/Team/debaratisah.jpg';
import SecondYear2 from '../../assets/Team/samanroy2.jpg';
import SecondYear3 from '../../assets/Team/ankana.jpg';
import SecondYear4 from '../../assets/Team/soumik.jpg';
import SecondYear5 from '../../assets/Team/shayak.jpg';
import SecondYear6 from '../../assets/Team/sagnik.jpg';
import SecondYear7 from '../../assets/Team/aniket.jpg';
import SecondYear8 from '../../assets/Team/sneha.jpg';
import SecondYear9 from '../../assets/Team/Subhradip Rakshit.jpg';
import SecondYear10 from '../../assets/Team/judhajeet.jpg';
import SecondYear11 from '../../assets/Team/kiranmayi.jpg';
import SecondYear12 from '../../assets/Team/trijit.jpg';


import ThirdYear1 from '../../assets/Team/sayak.jpg';
import ThirdYear2 from '../../assets/Team/Abhipriya Singh.jpg';
import ThirdYear3 from '../../assets/Team/triparna Das.jpg';
import ThirdYear4 from '../../assets/Team/abhishruta.jpg';
import ThirdYear5 from '../../assets/Team/sangam.jpg';
import ThirdYear6 from '../../assets/Team/rajshekhar.jpg';
import ThirdYear7 from '../../assets/Team/pragyan bagchi.jpg';
import ThirdYear8 from '../../assets/Team/Naman Agarwal.jpg';
import ThirdYear9 from '../../assets/Team/sujoy.jpeg';
import ThirdYear10 from '../../assets/Team/hirdaya.jpg';
import ThirdYear11 from '../../assets/Team/Aishwarya Rustagi.jpg';
import ThirdYear12 from '../../assets/Team/Nidhi Kumari.jpg';

const Faculty = [
    {
        img: Staff1,
        name: 'Debasis Chakraborty ',
        position: 'Faculty-in-charge',
        socialMedia: {
        }
    },
    {
        img: Staff2,
        name: 'Dr.Parag Kumar Guhathakurta',
        position: 'Faculty-in-charge',
        socialMedia: {
        }
    }
];

const FinalYear = [
    {
        img: President,
        name: 'Ankan Kumar Kundu',
        position: 'President',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/ankan-kumar-kundu-891742276?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/ankan_kk?igsh=aWhiYTZ5MnJ5am1l',
        }
    },
    {
        img: VicePresident,
        name: 'Souvik Sarkar',
        position: 'Vice President',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/souvik-sarkar-b187a02a0?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/svksrk_07?igsh=M3VkdGtyd3ExeWpo',
        }
    },
    {
        img: Secretary,
        name: 'Anamitra Hazra',
        position: 'General Secretary',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/anamitra-hazra-a33a75207/',
            instagram: 'https://www.instagram.com/deadlovepoetry/?__pwa=1',
        }
    },
    {
        img: convenor,
        name: 'Sahil Yadav',
        position: 'Convenor',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/sahil-yadav-23a8b8265?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/sahil_.ai?igsh=MTlkYWltbXlpaWYyZA==',
        }
    },
    {
        img: Treasurer,
        name: 'Pritam Das',
        position: 'Treasurer',
        socialMedia: {
        }
    },
    {
        img: Asst_Secretary,
        name: 'Ananthula Sriharshita',
        position: 'Assistant Secretary & GD head',
        socialMedia: {
        }
    },
    {
        img: sponsorship,
        name: 'Annwesha Naskar',
        position: 'Sponsorship Head',
        socialMedia: {
        }
    },
    {
        img: PR,
        name: 'Begari Prashanth',
        position: 'PR Head',
        socialMedia: {
        }
    },
    {
        img: TechHead,
        name: 'Ankit Pratap',
        position: 'Tech Head',
        socialMedia: {
        }
    },

];


const ThirdYear = [
    {
        img: ThirdYear1,
        name: 'Sayak Roy',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/sayak-roy-824b90292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/syk._.r?igsh=MW9xNjVkY2c2NXZwcw==',
        }
    },
    {
        img: ThirdYear2,
        name: 'Abhipriya Singh',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/abhipriya-singh-13b60a27a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/abhipriya_s_23?igsh=MWhja2xscmRrMm91cw==',
        }
    },
    {
        img: ThirdYear3,
        name: 'Triparna Das',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/triparna-das-6b139928a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/_trastae._?igsh=cmtpeHprbm1wZHN1',
        }
    },
    {
        img: ThirdYear4,
        name: 'Abhishruta Ghosh',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/abhishruta-ghosh-06b0ab295?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/abhis_hruta?igsh=MXcyZXIxbmVlenB6OQ==',
        }
    },
    {
        img: ThirdYear5,
        name: 'Sangam Saurav',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/sangam-saurav-248888287/',
            instagram: 'https://www.instagram.com/sangam_raj14/',
        }
    },
    {
        img: ThirdYear6,
        name: 'Rajshekhar Das',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/rajshekhar-das-a264b1212/',
            instagram: 'https://www.instagram.com/_outcast_raj/',
        }
    },
    {
        img: ThirdYear7,
        name: 'Pragyan Bagchi',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/pragyan-bagchi-4927a7302?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/_pragyan_bagchi_?igsh=cHJuMjl0c21kdjBx',
        }
    },
    {
        img: ThirdYear8,
        name: 'Naman Agarwal',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/namanag29?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/naman.agarwxl/',
        }
    },
    {
        img: ThirdYear9,
        name: 'Sujoy Basak',
        position: '',
        socialMedia: {
            linkedin: 'http://www.linkedin.com/in/sujoy-basak-577098351',
            instagram: 'https://www.instagram.com/_s.u.j.o.y?igsh=aXEzdzJyczA2Znk4',
        }
    },
    {
        img: ThirdYear10,
        name: 'Hridaya Gopal Das',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/hridaya-gopal-das-12a554287?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/hridaya.16?igsh=MW9kaHUyMzZ6c242ZA==',
        }
    },
    {
        img: ThirdYear11,
        name: 'Aishwarya Rustagi',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/aishwarya-rustagi-606a37293?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/_aishiyy_/',
        }
    },
    {
        img: ThirdYear12,
        name: 'Nidhi Kumari',
        position: '',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/nidhi-kumari-b297782ba/',
            instagram: 'https://www.instagram.com/nidhi__k_62/',
        }
    }
];

const SecondYears = [
    {
        img: SecondYear1,
        name: 'Debarati Sah',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/debarati-sah-7308a1341',
            instagram: 'https://www.instagram.com/invites/contact/?igsh=1fo2y71myo2j6&utm_content=vj9px2v',
        }
    },
    {
        img:SecondYear2,
        name: 'Samam Roy',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://in.linkedin.com/in/samam-roy-732191328',
            instagram: 'https://www.instagram.com/_._.frenzied._._?igsh=MWFwanBjd3Q0YTd5Yg==',
        }
    },
    {
        img:SecondYear3,
        name: 'Ankana Chakraborty',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/ankana-chakraborty-58960a267?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/_ano_nymous7?igsh=MWtuaTBwdTI4bXpuOQ==',
        }
    },
    {
        img: SecondYear4,
        name: 'Soumik Parui',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/soumik-parui-033b67347?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/its_._soumik?igsh=YmNhMm03YWZoemMw',
        }
    },
    {
        img: SecondYear5,
        name: 'Shayak Dutta',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/shayak-dutta-3b275b31b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/shayak_iwnl?igsh=Ym5objJmZWRybm1s',
        }
    },
    {
        img: SecondYear6,
        name: 'Sagnik Roy',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/sagnik-roy-03747a260',
            instagram: 'https://www.instagram.com/sagnik3008/',
        }
    },
    {
        img: SecondYear7,
        name: 'Aniket Haldar',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/aniket-haldar-499551260/',
            instagram: 'https://www.instagram.com/aniketlmao/',
        }
    },
    {
        img: SecondYear8,
        name: 'Sneha Roy',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/sneha-roy-a794bb351?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/lass.with.a.bindi?igsh=MWFzb2cxcHpyMTh4eQ==',
        }
    },
    {
        img: SecondYear9,
        name: 'Subhradip Rakshit',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/subhradip-rakshit-7697a432a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/rakshit_subhradip_220/',
        }
    },
    {
        img: SecondYear10,
        name: 'Judhajeet Ghosh',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/judhajeet-ghosh-215867344',
            instagram: 'https://www.instagram.com/justjee.t/',
        }
    },
    {
        img: SecondYear11,
        name: 'Kiranmayi',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/kiranmayi-taduvayi-2b504a331?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
            instagram: 'https://www.instagram.com/kiranmayi2276?igsh=MWxnY24wcjR2NWZmbQ==',
        }
    },
    {
        img: SecondYear12,
        name: 'Trijit Goswami',
        position: 'Team Member',
        socialMedia: {
            linkedin: 'https://www.linkedin.com/in/trijit-goswami-477509351',
            instagram: 'https://www.instagram.com/_trijit__?igsh=MWpqbGxyNXQ2N3JkMw==',
        }
    }
    
];

const SocialMediaIcons = ({ socialMedia }) => {
    return (
        <div className="social-icons">
            {socialMedia.twitter && (
                <a href={socialMedia.twitter} target="_blank" rel="noopener noreferrer" className='twitter'>
                    <FaTwitter />
                </a>
            )}
            {socialMedia.linkedin && (
                <a href={socialMedia.linkedin} target="_blank" rel="noopener noreferrer" className='linkedin'>
                    <FaLinkedin />
                </a>
            )}
            {socialMedia.instagram && (
                <a href={socialMedia.instagram} target="_blank" rel="noopener noreferrer" className='instagram'>
                    <FaInstagram />
                </a>
            )}
        </div>
    );
};

const Ourteam = () => {
    useEffect(() => {
        const elements = document.querySelectorAll('.scroll-up');
        elements.forEach((el, index) => {
            el.style.animationDelay = `${index * 0.2}s`;
        });
    }, []);

    return (
        <div>
            <div className="our-team">
                <h1 className="scroll-up">Our Team</h1>
                
                {/* Faculty Advisors Section */}
                <h2 className="scroll-up">Faculty Advisors</h2>
                <div className="faculty-in-charge">
                    {Faculty.map((item, index) => (
                        <div className="ex-com-member scroll-up" key={index}>
                            <img className="ex-com-member-img" src={item.img} alt="" />
                            <h3>{item.name}</h3>
                            <p>{item.position}</p>
                            <SocialMediaIcons socialMedia={item.socialMedia} />
                        </div>
                    ))}
                </div>

                {/* Executive Committee Section */}
                <h2 className="excom-title scroll-up">Final Year</h2>
                <div className="ex-com">
                    {FinalYear.map((item, index) => (
                        <div className="ex-com-member scroll-up" key={index}>
                            <img className="ex-com-member-img" src={item.img} alt="" />
                            <h3>{item.name}</h3>
                            <p>{item.position}</p>
                            <SocialMediaIcons socialMedia={item.socialMedia} />
                        </div>
                    ))}
                </div>

                {/* Third years Section */}
                <h2 className="scroll-up">Pre-Final Year</h2>
                <div className="creative-team">
                    {ThirdYear.map((item, index) => (
                        <div className="team-member scroll-up" key={index}>
                            <img className="team-member-img" src={item.img} alt="" />
                            <h3>{item.name}</h3>
                            <p>{item.position}</p>
                            <SocialMediaIcons socialMedia={item.socialMedia} />
                        </div>
                    ))}
                </div>

                {/* First Year Section */}
                <h2 className="scroll-up">SecondYears</h2>
                <div className="content-team">
                    {SecondYears.map((item, index) => (
                        <div className="team-member scroll-up" key={index}>
                            <img className="team-member-img" src={item.img} alt="" />
                            <h3>{item.name}</h3>
                            <p>{item.position}</p>
                            <SocialMediaIcons socialMedia={item.socialMedia} />
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default Ourteam;
